export default "__VITE_ASSET__BlLI9nv3__"